import { FilterMultiSelect } from "@/components/common/FilterMultiSelect";
import { TableFilterControls } from "@/hooks/common/table/use-table-controls";

type Props = Readonly<
  TableFilterControls & {
    children?: React.ReactNode;
    labelledBy?: string;
  }
>;

export const TableFilter = ({ onChange, onValuesChange, options, children, labelledBy }: Props) => {
  const selectedValues = options.filter((option) => option.isSelected).map((option) => option.value);

  return (
    <>
      {children}

      <FilterMultiSelect
        compact
        labelledBy={labelledBy}
        options={options}
        value={selectedValues}
        onChange={(nextValues) => {
          if (onValuesChange) {
            onValuesChange(nextValues);
            return;
          }

          const changedOptions = options.filter((option) => option.isSelected !== nextValues.includes(option.value));
          changedOptions.forEach((option) => onChange?.(option.value, nextValues.includes(option.value)));
        }}
      />
    </>
  );
};
